import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/hand-point-left': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M0 220.8C0 266.4 37.8 304 83.2 304H118.8A93.1-93.1 0 0 1 126.8 326.1C124.3 348.1 130.3 371 142.8 388.9 143.9 441.3 180.2 480 242.7 480H264C324.1 480 362.5 440 391.2 440H393.9C399.6 445 407.4 448 416 448H480C497.7 448 512 435.1 512 419.2V188.8C512 172.9 497.7 160 480 160H416C407.4 160 399.6 163 393.9 168H391.2C384.2 168 376.3 161.8 361 144.3L360.9 144.2 360.8 144C351.9 134.1 342.6 123.2 334.9 110.8 316.2 80.5 304.5 32 259.2 32 202.3 32 167.2 67.3 167.2 115.2 167.2 123.2 168 130.7 169.4 137.6H83.2C38.1 137.6 0 175.7 0 220.8zM48 220.8C48 202.1 64.8 185.6 83.2 185.6H241.6C241.6 168.3 215.2 150.4 215.2 115.2 215.2 88.8 235.8 80 259.2 80 268 80 279.6 112.7 294.1 136.1 303.2 150.7 313.7 163.3 324.9 176 341 194.3 358.8 212.6 384 215.6V392.3C341.2 396.1 309.5 432 264 432H242.7C202.2 432 185.6 409.8 192.1 370.7 177.5 362.7 167.9 336.7 179.2 317.1 159.8 298.8 161.4 270.7 174.2 256H83.2C64.2 256 48 239.8 48 220.8zM448 360C461.3 360 472 370.7 472 384S461.3 408 448 408 424 397.3 424 384 434.7 360 448 360z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/hand-point-left.js
// module id = ZFbk
// module chunks = 144